import { CREATE_INITIATE_PROMOTION, GET_INITIATE_PROMOTION } from "./types";

import { CreatePromotionType } from "@type/HRM/promotion-candidates";

export const getInitiatePromotionRequest = () => {
  return {
    type: GET_INITIATE_PROMOTION.GET_INITIATE_PROMOTION_REQUEST,
  };
};

export const getInitiatePromotionSuccess = (data: CreatePromotionType) => {
  return {
    type: GET_INITIATE_PROMOTION.GET_INITIATE_PROMOTION_SUCCESS,
    payload: {
      data,
    },
  };
};

export const getInitiatePromotionFailed = () => {
  return {
    type: GET_INITIATE_PROMOTION.GET_INITIATE_PROMOTION_FAILED,
  };
};

export const createInitiatePromotionRequest = (data: CreatePromotionType) => {
  return {
    type: CREATE_INITIATE_PROMOTION.CREATE_INITIATE_PROMOTION_REQUEST,
    payload: {
      data,
    },
  };
};

export const createInitiatePromotionSuccess = (data: CreatePromotionType) => {
  return {
    type: CREATE_INITIATE_PROMOTION.CREATE_INITIATE_PROMOTION_SUCCESS,
    payload: {
      data,
    },
  };
};

export const createInitiatePromotionFailed = () => {
  return {
    type: CREATE_INITIATE_PROMOTION.CREATE_INITIATE_PROMOTION_FAILED,
  };
};

export type InitiatePromotionsActions =
  | ReturnType<typeof getInitiatePromotionRequest>
  | ReturnType<typeof getInitiatePromotionSuccess>
  | ReturnType<typeof getInitiatePromotionFailed>
  | ReturnType<typeof createInitiatePromotionRequest>
  | ReturnType<typeof createInitiatePromotionSuccess>
  | ReturnType<typeof createInitiatePromotionFailed>;
